import React from 'react'
import ListDragItems from './ListDragItems'
import ButtonLink from '../../general/ButtonLink'
import ListToggleDisplayWrapper from './ListToggleDisplayWrapper'


const ListDrag = ({
    titleTransId,
    buttonTextTransId,
    listId,
    dndType  = false,
    className = '', 

    type, 

    order, 
    items,
    selected,

    ChildSwitchItem,

    params=false,
    basicUrl=false,

    defaultIsOpen,

    canEdit,
    canDelete,
    pathnameAdd,
    deleteItem,
    setAllOpen,

    children
}) => (
    <ListToggleDisplayWrapper
        className={className}
        titleTransId={titleTransId}
        defaultIsOpen={defaultIsOpen}
        setAllOpen={setAllOpen}
    >
        <>
            {children}

            <ul className="grid-container">
                <ListDragItems
                    listId={listId}
                    type={type}
                    dndType={dndType}
                    order={order}
                    items={items} 
                    ChildSwitchItem={ChildSwitchItem}
                    selected={selected}
                    params={params}
                    basicUrl={basicUrl}
                    canEdit={canEdit}
                    canDelete={canDelete}
                    deleteItem={deleteItem}
                />
            </ul>

            {pathnameAdd && <ButtonLink
                pathname={pathnameAdd}
                className="button-add"
                transId={buttonTextTransId}
                hideText={false}
            />}
        </>
    </ListToggleDisplayWrapper>
)

export default ListDrag